var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_american-express",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.24,
    height: 21.288,
    viewBox: "0 0 61.24 21.288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M43.2,187.922h2.139L44.269,185.2Z",
    transform: "translate(-37.951 -182.673)",
    fill: "#2fabf7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M241.922,187.7a1.9,1.9,0,0,0-.778-.1H239.2v1.555h1.944a1.9,1.9,0,0,0,.778-.1.757.757,0,0,0,.292-.68A.54.54,0,0,0,241.922,187.7Z",
    transform: "translate(-210.135 -184.781)",
    fill: "#228fe0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M52.589,164.4v1.166l-.583-1.166H47.437v1.166l-.583-1.166H40.633a5.918,5.918,0,0,0-2.722.583V164.4H33.536v.583a2.8,2.8,0,0,0-1.847-.583H16.039l-1.069,2.43L13.9,164.4H8.943v1.166L8.36,164.4H4.18l-1.944,4.569L0,174.023H4.958l.583-1.555H6.9l.583,1.555h5.638v-1.166l.486,1.166h2.819l.486-1.166v1.166H30.426V171.5h.194c.194,0,.194,0,.194.292v2.139h7v-.583a5.823,5.823,0,0,0,2.625.583h2.916l.583-1.555H45.3l.583,1.555H51.52v-1.458l.875,1.458h4.569V164.4Zm-32.856,8.165H18.081v-5.346l-2.333,5.346H14.289l-2.333-5.346v5.346H8.651l-.68-1.458H4.666l-.583,1.555H2.236l2.916-6.9h2.43l2.722,6.513v-6.513h2.625l2.139,4.666,1.944-4.666h2.722Zm6.61-5.346H22.552v1.264h3.694v1.361H22.552V171.2h3.791v1.458H20.9v-6.9h5.444Zm7.291,2.819a2.432,2.432,0,0,1,.292,1.264v1.361H32.273v-.875a2.316,2.316,0,0,0-.292-1.361c-.292-.292-.583-.292-1.166-.292h-1.75v2.527H27.412v-6.9h3.694a3.727,3.727,0,0,1,1.944.292,1.656,1.656,0,0,1,.778,1.555,1.935,1.935,0,0,1-1.166,1.847A1.848,1.848,0,0,1,33.634,170.038Zm2.916,2.527H34.9v-6.9H36.55Zm19.15,0H53.367l-3.111-5.152v5.152H46.951l-.583-1.458h-3.4l-.583,1.555H40.535a2.923,2.923,0,0,1-3.208-3.4,3.985,3.985,0,0,1,.875-2.722,3.064,3.064,0,0,1,2.43-.778h1.555v1.458H40.633a1.793,1.793,0,0,0-1.264.389,2.283,2.283,0,0,0-.486,1.555,2.115,2.115,0,0,0,.486,1.653,1.55,1.55,0,0,0,1.166.389h.68l2.236-5.346h2.43l2.722,6.513v-6.513h2.43l2.819,4.763v-4.763h1.653v6.707Z",
    transform: "translate(0 -164.4)",
    fill: "#0571c1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(24.496 2.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M358.4,187.922h2.236l-1.069-2.722Z",
    transform: "translate(-339.347 -185.2)",
    fill: "#228fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M204.127,282.741V277.2l-2.527,2.722Z",
    transform: "translate(-201.6 -266.021)",
    fill: "#228fe0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M136.8,282.8v1.264h3.6v1.361h-3.6v1.458h3.985l1.847-2.041-1.75-2.041Z",
    transform: "translate(-120.178 -268.413)",
    fill: "#2fabf7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    d: "M238.041,282.8H236v1.75h2.139c.583,0,.972-.292.972-.875A.98.98,0,0,0,238.041,282.8Z",
    transform: "translate(-207.324 -268.413)",
    fill: "#228fe0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M158.443,264.774V260.4H154.36a3.189,3.189,0,0,0-2.041.583V260.4h-4.471a3.084,3.084,0,0,0-1.944.583V260.4h-7.874v.583a3.757,3.757,0,0,0-2.139-.583h-5.249v.583a3.688,3.688,0,0,0-2.236-.583h-5.832l-1.361,1.458-1.264-1.458H111.2v9.526h8.554l1.361-1.458,1.264,1.458h5.249V267.69h.68a5.914,5.914,0,0,0,2.236-.292v2.625h4.374V267.5h.194c.292,0,.292,0,.292.292v2.236h13.22a3.811,3.811,0,0,0,2.236-.583v.583h4.18a4.366,4.366,0,0,0,2.333-.486h0a3.309,3.309,0,0,0,1.555-2.916A3.722,3.722,0,0,0,158.443,264.774Zm-30.134,1.555h-1.944v2.333h-3.111l-1.944-2.236-2.041,2.236h-6.416v-6.9h6.513L121.31,264l2.041-2.236H128.5c1.264,0,2.722.389,2.722,2.236C131.127,265.941,129.767,266.33,128.308,266.33Zm9.721-.389a2.206,2.206,0,0,1,.292,1.264v1.361h-1.653v-.875a2.17,2.17,0,0,0-.292-1.361c-.194-.292-.583-.292-1.167-.292h-1.75v2.527h-1.652v-6.9H135.5a3.914,3.914,0,0,1,1.944.292,1.719,1.719,0,0,1,.875,1.555,1.935,1.935,0,0,1-1.166,1.847A1.663,1.663,0,0,1,138.029,265.941Zm6.707-2.819h-3.791v1.264h3.694v1.361h-3.694v1.361h3.791v1.458h-5.444v-6.9h5.444Zm4.083,5.444h-3.111v-1.458h3.111a.82.82,0,0,0,.68-.194.7.7,0,0,0,0-.972.822.822,0,0,0-.583-.194c-1.555-.1-3.4,0-3.4-2.139,0-.972.583-2.041,2.333-2.041h3.208v1.652h-3.013a1.441,1.441,0,0,0-.68.1c-.194.1-.194.292-.194.486,0,.292.194.389.389.486a1.232,1.232,0,0,0,.583.1h.875a2.475,2.475,0,0,1,1.847.583,2.012,2.012,0,0,1,.486,1.458C151.346,267.885,150.472,268.565,148.819,268.565Zm8.36-.68a2.835,2.835,0,0,1-2.041.68h-3.111v-1.458h3.111a.82.82,0,0,0,.68-.194.7.7,0,0,0,0-.972.822.822,0,0,0-.583-.194c-1.555-.1-3.4,0-3.4-2.139,0-.972.583-2.041,2.333-2.041h3.208v1.652h-2.916a1.442,1.442,0,0,0-.68.1c-.194.1-.194.292-.194.486,0,.292.1.389.389.486a1.232,1.232,0,0,0,.583.1h.875a2.475,2.475,0,0,1,1.847.583.1.1,0,0,1,.1.1,2.232,2.232,0,0,1,.389,1.361A1.978,1.978,0,0,1,157.179,267.885Z",
    transform: "translate(-97.688 -248.735)",
    fill: "#0571c1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_1",
    d: "M297.922,283.7a1.9,1.9,0,0,0-.778-.1H295.2v1.555h1.944a1.9,1.9,0,0,0,.778-.1.757.757,0,0,0,.292-.68A.54.54,0,0,0,297.922,283.7Z",
    transform: "translate(-259.331 -269.116)",
    fill: "#228fe0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(24.496 2.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M241.922,187.7a1.9,1.9,0,0,0-.778-.1H239.2v1.555h1.944a1.9,1.9,0,0,0,.778-.1.757.757,0,0,0,.292-.68A.54.54,0,0,0,241.922,187.7Z",
    transform: "translate(-234.631 -187.308)",
    fill: "#228fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M358.4,187.922h2.236l-1.069-2.722Z",
    transform: "translate(-339.347 -185.2)",
    fill: "#228fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M204.127,282.741V277.2l-2.527,2.722Z",
    transform: "translate(-201.6 -266.021)",
    fill: "#228fe0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(28.676 14.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    d: "M238.041,282.8H236v1.75h2.139c.583,0,.972-.292.972-.875A.98.98,0,0,0,238.041,282.8Z",
    transform: "translate(-236 -282.8)",
    fill: "#228fe0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(35.869 14.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_1_1_",
    d: "M297.922,283.7a1.9,1.9,0,0,0-.778-.1H295.2v1.555h1.944a1.9,1.9,0,0,0,.778-.1.757.757,0,0,0,.292-.68A.54.54,0,0,0,297.922,283.7Z",
    transform: "translate(-295.2 -283.6)",
    fill: "#228fe0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M127.725,268.371l-1.361-1.458v1.652h-3.208l-1.944-2.236-2.139,2.236h-6.416v-6.8h6.513L121.212,264l.972-1.167-2.43-2.43H111.2v9.526h8.554l1.458-1.458,1.264,1.458h5.249Z",
    transform: "translate(-97.688 -248.735)",
    fill: "#2fabf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M19.927,173.926l-1.264-1.361h-.583v-.583l-1.458-1.458-.972,2.041H14.289l-2.333-5.346v5.346H8.651l-.68-1.458H4.666l-.68,1.458H2.236l2.916-6.8h2.43l2.722,6.513v-6.513h1.458L10.4,164.4H8.943v1.166L8.457,164.4H4.18l-1.944,4.569L0,173.926H5.055l.583-1.458H7l.68,1.458h5.444V172.76l.486,1.166h2.819l.486-1.166v1.166Z",
    transform: "translate(0 -164.4)",
    fill: "#2fabf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M115.955,194.755,114.4,193.2l1.166,2.527Z",
    transform: "translate(-100.499 -189.701)",
    fill: "#2fabf7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(9.624 0.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M212.894,267.332a3.556,3.556,0,0,0,1.555-2.625l-1.361-1.361a2.875,2.875,0,0,1,.194.972,1.978,1.978,0,0,1-.583,1.458,2.835,2.835,0,0,1-2.041.68h-3.111V265h3.111a.82.82,0,0,0,.68-.194.7.7,0,0,0,0-.972.822.822,0,0,0-.583-.194c-1.555-.1-3.4,0-3.4-2.139,0-.972.583-1.847,2.041-2.041l-1.069-1.069c-.194.1-.292.194-.389.194V258h-4.472a3.085,3.085,0,0,0-1.944.583V258H193.55v.583a3.758,3.758,0,0,0-2.139-.583h-5.249v.583a3.689,3.689,0,0,0-2.236-.583h-5.832l-1.361,1.458L175.469,258H174.4l2.916,2.916,1.458-1.555h5.152c1.264,0,2.722.389,2.722,2.236,0,1.944-1.361,2.333-2.819,2.333h-1.944v1.458l1.458,1.458v-1.458h.486a5.913,5.913,0,0,0,2.236-.292v2.625h4.374v-2.527h.194c.292,0,.292,0,.292.292v2.236h13.22a3.811,3.811,0,0,0,2.236-.583v.583h4.18a3.856,3.856,0,0,0,2.333-.389Zm-19.344-3.5a2.205,2.205,0,0,1,.292,1.264v1.361h-1.653v-.875a2.17,2.17,0,0,0-.292-1.361c-.194-.292-.583-.292-1.166-.292h-1.75v2.527h-1.652v-6.9h3.694a3.913,3.913,0,0,1,1.944.292,1.719,1.719,0,0,1,.875,1.555,1.935,1.935,0,0,1-1.166,1.847A1.662,1.662,0,0,1,193.55,263.832Zm6.707-2.819h-3.791v1.264h3.694v1.361h-3.694V265h3.791v1.458h-5.444v-6.9h5.444Zm4.083,5.444h-3.111V265h3.111a.82.82,0,0,0,.68-.194.7.7,0,0,0,0-.972.822.822,0,0,0-.583-.194c-1.555-.1-3.4,0-3.4-2.139,0-.972.583-2.041,2.333-2.041h3.208v1.652h-3.013a1.44,1.44,0,0,0-.68.1c-.194.1-.194.292-.194.486,0,.292.194.389.389.486a1.233,1.233,0,0,0,.583.1h.875a2.475,2.475,0,0,1,1.847.583,2.012,2.012,0,0,1,.486,1.458C206.867,265.777,205.992,266.457,204.34,266.457Z",
    transform: "translate(-162.832 -246.724)",
    fill: "#228fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M459.2,284.183c0,.292.1.389.389.486a1.234,1.234,0,0,0,.583.1h.875a2.823,2.823,0,0,1,1.361.292L460.95,283.6h-.875a1.441,1.441,0,0,0-.68.1A.742.742,0,0,0,459.2,284.183Z",
    transform: "translate(-413.027 -269.213)",
    fill: "#228fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M431.2,240.4l.194.292h.1Z",
    transform: "translate(-388.429 -231.263)",
    fill: "#228fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M387.2,196.4l1.653,3.986v-2.333Z",
    transform: "translate(-349.775 -192.609)",
    fill: "#228fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M100,172.2h.194c.194,0,.194,0,.194.292v2.139h7v-.583a5.823,5.823,0,0,0,2.625.583h2.916l.583-1.555h1.361l.583,1.555H121.1v-.972l-1.361-1.361v1.069H116.43l-.486-1.555h-3.4l-.583,1.555h-1.847a2.923,2.923,0,0,1-3.208-3.4,3.985,3.985,0,0,1,.875-2.722,3.064,3.064,0,0,1,2.43-.778h1.555v1.458h-1.555a1.793,1.793,0,0,0-1.264.389,2.283,2.283,0,0,0-.486,1.555,2.115,2.115,0,0,0,.486,1.653,1.55,1.55,0,0,0,1.166.389h.68l2.236-5.346H114l-1.361-1.361h-2.527a5.919,5.919,0,0,0-2.722.583V165.2h-4.277v.583a2.8,2.8,0,0,0-1.847-.583H85.616l-1.069,2.43-1.069-2.43H79.2l1.361,1.361h1.944l1.653,3.6.583.583,1.75-4.277h2.722v6.9H87.56v-5.346l-1.653,3.888,2.819,2.819H99.905Zm4.472-5.735h1.653v6.9h-1.653Zm-8.554,1.458H92.129v1.264h3.694v1.361H92.129v1.361H95.92v1.458H90.476v-6.9H95.92Zm2.722,5.346H96.989v-6.9h3.694a3.727,3.727,0,0,1,1.944.292,1.656,1.656,0,0,1,.778,1.555,1.935,1.935,0,0,1-1.166,1.847,1.273,1.273,0,0,1,.778.583,2.432,2.432,0,0,1,.292,1.264v1.361h-1.653v-.875a2.316,2.316,0,0,0-.292-1.361c-.1-.194-.389-.194-.972-.194h-1.75v2.43Z",
    transform: "translate(-79.2 -165.2)",
    fill: "#228fe0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.ddc8be473b0cbb4ae963284841adbfd9.svg";
export { ForwardRef as ReactComponent };